import { AppHeader } from '@web_opxp/components';
import { ObFlowService } from '@web_opxp/features';
import { useTranslation } from '@web_opxp/language';
import * as React from 'react';
import { useLocation } from 'react-router';
import { HistoryService } from 'web_core_library';
import ENV from '../../base/env';
import { isCustomObFlowActive, isSubscribe } from '../../base/utils';
import { getMenu } from './menu';
import { getUserMenu } from './userMenuItems';

export interface IHeaderWrapperProps {
  loading: boolean;
  isPremium: boolean;
  session: string | undefined;
  // unread status: messages
  regular: number;
  // unread status: friendship requests
  friendship: number;
  // user picture
  picture?: string;
  // user is authorized
  authorized?: boolean;
  // user name/email
  alias?: string;
  isLoggedIn: boolean;
  // user menu item click handler
  onUserMenuAction: (actionType: string) => void;
  // login click handler
  onLogin: () => void;
}

export const HeaderWrapper: React.FC<IHeaderWrapperProps> = ({
  isPremium,
  session,
  loading,
  regular,
  friendship,
  picture,
  authorized,
  alias,
  isLoggedIn,
  onUserMenuAction,
  onLogin,
}) => {
  const { t, language } = useTranslation();
  const location = useLocation();

  if (!language || loading) {
    return null;
  }

  const isOnSubscribePage = isSubscribe(location.pathname);
  const obFlowActive = isCustomObFlowActive();
  const nextObStep = isOnSubscribePage && obFlowActive ? ObFlowService.getNextObStep('subscribe') : null;
  // getNextObUrl will return link to training app if next step is null
  const obLink = ObFlowService.getNextObUrl(nextObStep, language, session);
  const fallbackLink = HistoryService.getTrainingUrl('', language, session);
  const logoLink = obLink !== '' ? obLink : fallbackLink;

  const menuLabel = authorized ? alias : t('common:Header.Menu.Login');
  const loginHandler = () => {
    if (authorized) return;
    onLogin();
  };
  const userMenu = authorized ? getUserMenu(onUserMenuAction, language, session, regular, friendship) : [];
  const navMenu = getMenu(
    isLoggedIn,
    isPremium,
    language,
    session,
    menuLabel,
    userMenu,
    regular + friendship,
    picture ?? 'default',
    loginHandler
  );

  return (
    <AppHeader
      logoLabel={t('common:Header.Logo') ?? ''}
      logoLink={logoLink}
      logoSrc={`${ENV.AssetsBaseUrl}/logo.svg`}
      menuItems={navMenu}
    />
  );
};

export default HeaderWrapper;
